export const TEAMS_FI = {
    
}